import React from 'react';
import { TextField, Switch, FormControlLabel, Select, MenuItem, Box, Tooltip } from '@mui/material';
import { FieldMetadata } from '../../config/userUploaderConfig';

interface CustomValueInputProps {
  field: FieldMetadata;
  value: unknown;
  onChange: (value: unknown) => void;
  disabled?: boolean;
}

const CustomValueInput: React.FC<CustomValueInputProps> = ({ field, value, onChange, disabled = false }) => {
  if (field.type === 'boolean') {
    return (
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={typeof value === 'boolean' ? value : false}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
          />
        }
        label={value ? 'Verdadero' : 'Falso'}
        sx={{ m: 0 }}
      />
    );
  }

  if (field.selectOptions && field.allowCustomInputForSelect) {
    const isCustom = value !== undefined && value !== null && !field.selectOptions.some((o) => o.value === value);
    return (
      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
        <Select
          size="small"
          value={isCustom ? '__custom__' : (value as string) || ''}
          disabled={disabled}
          onChange={(e) => {
            if (e.target.value === '__custom__' || e.target.value === '') {
              onChange(e.target.value === '' ? undefined : '');
            } else {
              onChange(e.target.value);
            }
          }}
          sx={{ minWidth: 80, flex: 1 }}
        >
          <MenuItem value=""><em>Ninguno</em></MenuItem>
          {field.selectOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
          ))}
          <MenuItem value="__custom__"><em>Personalizado...</em></MenuItem>
        </Select>
        {isCustom && (
          <TextField
            size="small"
            value={(value as string) || ''}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Valor personalizado"
            sx={{ flex: 1 }}
          />
        )}
      </Box>
    );
  }

  if (field.selectOptions) {
    return (
      <Select
        size="small"
        fullWidth
        value={(value as string) || ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value || undefined)}
      >
        <MenuItem value=""><em>Ninguno</em></MenuItem>
        {field.selectOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <Tooltip title={field.helperText || ''} placement="top">
      <TextField
        size="small"
        fullWidth
        type={field.type === 'number' ? 'number' : 'text'}
        value={value !== undefined && value !== null ? String(value) : ''}
        disabled={disabled}
        placeholder="Valor por defecto"
        onChange={(e) => onChange(field.type === 'number' ? (e.target.value === '' ? undefined : parseFloat(e.target.value)) : e.target.value)}
      />
    </Tooltip>
  );
};

export default CustomValueInput;
